module.exports = __webpack_public_path__ + "assets/img/36_527_big.fd14bc01.jpg";